// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentOrdersStyles } from "@gcg/Overrides/Widgets/Common/RecentOrders";
import { screen } from "@gcg/XDL/Helpers";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

recentOrdersStyles.addToCartCells = {
    css: css`
        span {
            font-weight: bold;
            color: ${getColor("common.ui8")};
        }
    `,
};
recentOrdersStyles.headerContainer = {
    css: css`
        width: 100%;
        display: flex;

        ${screen("lt", "sm")`
            display: block;
        `}
    `,
};
recentOrdersStyles.linksWrapper = {
    css: css`
        width: 60%;
        display: flex;
        justify-content: space-between;

        ${screen("lt", "sm")`
            width:100%;      
        `}
    `,
};
recentOrdersStyles.title = {
    css: css`
        width: 40%;
        
        ${screen("lt", "sm")`
            width:100%;
        `}
    `,
};
